import { cssVariables, getRemainingDays } from "@/utils/utils";
import { Popover } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { formatLocaleDate } from "../../../../../../common/utils/formatUtils";
import { tInterval } from "../../../../../../common/utils/translationUtils";
import { DashboardGoal } from "../../../../types";
import { getRemainingPercent } from "../../../../utils";
import { GoalCard } from "../cards/GoalCard";

type Props = {
  goal: DashboardGoal;
  year: number;
  agentId: string;
};

export const TipperStatusWrapper = ({ goal, year, agentId }: Props) => {
  const { t } = useTranslation();

  const remainingDays = getRemainingDays(dayjs(), dayjs(goal.targetDate));
  const totalDays = dayjs(goal.targetDate).startOf("day").diff(dayjs().startOf("year"), "days");
  const remainingPercent = getRemainingPercent(totalDays, remainingDays);

  return (
    <GoalCard
      agentId={agentId}
      year={year}
      goal={goal}
      label={
        <span style={{ fontSize: 20 }}>
          <Popover content={t("dashboard.goals.helpers.statusGoalHint")}>
            {t("dashboard.enums.dashboardGoalType.TIPPER_STATUS")}
          </Popover>
        </span>
      }
      percentage={goal.dateGoalReached ? 100 : remainingPercent}
      hasTarget
      targetLabel={
        <div
          style={{
            color:
              remainingDays > 14 ? "white" : remainingDays === 0 ? cssVariables.colorRed : cssVariables.colorOrange,
          }}
          className="margin-top-small"
        >
          <p className="margin-bottom-tiny" style={{ fontSize: 16 }}>
            {t("dashboard.goals.helpers.remain")}
          </p>
          <p className="margin-bottom-tiny">{remainingDays}</p>
          <p className="margin-bottom-tiny" style={{ fontSize: 16 }}>
            {tInterval("dashboard.goals.helpers.days_interval", remainingDays)}
          </p>
        </div>
      }
      tooltipTitle={
        <div>
          {t("dashboard.goals.helpers.targetDate")}: {goal.targetDate ? formatLocaleDate(goal.targetDate) : undefined}
        </div>
      }
    />
  );
};
